import React, { useEffect } from "react";
import Header from "../components/Header";
import EmergencyBanner from "../components/EmergencyBanner";
import Hero from "../components/Hero";
import Services from "../components/Services";
import WhyUs from "../components/WhyUs";
import SeoContent from "../components/SeoContent";
import Reviews from "../components/Reviews";
import CitiesGrid from "../components/CitiesGrid";
import Faq from "../components/Faq";
import MapEmbed from "../components/MapEmbed";
import Footer from "../components/Footer";
import MobileStickyCTA from "../components/MobileStickyCTA";

const Home = () => {
  useEffect(() => {
    document.title = "Debouchage canalisation 93 - Au 01.84.16.20.60";
    const setMeta = (name, content, attr = "name") => {
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setMeta(
      "description",
      "Débouchage canalisation 93 : intervention 24h/24 et 7j/7 dans toute la Seine-Saint-Denis. Plombier expert dégorgement, WC bouché, évacuation, curage. Appelez le 01.84.16.20.60."
    );
    setMeta(
      "keywords",
      "Debouchage canalisation 93, Canalisation bouchée 93, Debouchage Toilette 93, entreprise de debouchage canalisation 93, societe Debouchage canalisation 93, probleme canalisation 93, wc bouché 93, curage canalisation 93"
    );
    setMeta("og:title", "Debouchage canalisation 93 - Au 01.84.16.20.60", "property");
    setMeta(
      "og:description",
      "Expert n°1 du débouchage canalisation en Seine-Saint-Denis. Urgence 24/7, 30 min, devis gratuit.",
      "property"
    );
  }, []);

  return (
    <>
      <EmergencyBanner />
      <Header />
      <main>
        <Hero city={null} />
        <Services />
        <WhyUs />
        <SeoContent city={null} />
        <Reviews />
        <CitiesGrid />
        <Faq />
        <MapEmbed />
      </main>
      <Footer />
      <MobileStickyCTA />
    </>
  );
};

export default Home;
